import styled, { hexToRgba } from '../../theme/styled'

const linkEffect =
  '&:hover { transform: scale(1.02, 1.02); }' +
  '&:focus { transform: scale(1.02, 1.02); }' +
  '&:active { }' +
  '&:disabled { opacity: 0.3; transform: none; cursor: default; }'

const linkEffectAlt =
  '&:hover { font-weight: bold; }' +
  '&:focus { font-weight: bold; }' +
  '&:active {  }' +
  '&:disabled { opacity: 0.2; cursor: default; }' +
  '&:disabled:hover { font-weight: normal; }' +
  '&:disabled:focus { font-weight: normal; }'

const fieldBasics = ' font-size: 1rem; height: 2em; width: 100%;'
const fieldValue = ' margin-bottom: .5em; font-weight: bold;' + fieldBasics
const bigFieldValue = ' font-weight: bold;' + fieldBasics

export const SpinnerDiv = styled.div`
  min-height: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex: 1 0 100%;
  flex-direction: column;

  .spinner {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 60px;
    height: 60px;
    margin: -30px 0 0 -30px;

    animation: rotation 1s infinite linear;
    border-left: 6px solid
      ${({ theme }) => hexToRgba(theme.colors.brand, '0.15')};
    border-right: 6px solid
      ${({ theme }) => hexToRgba(theme.colors.brand, '0.15')};
    border-bottom: 6px solid r
      ${({ theme }) => hexToRgba(theme.colors.brand, '0.15')};
    border-top: 6px solid ${({ theme }) => hexToRgba(theme.colors.brand, '0.9')};
    border-radius: 100%;
  }

  @keyframes rotation {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(359deg);
    }
  }
`

export const DarkMain = styled.div`
  background: ${({ theme }) => theme.colors.default};
  color: ${({ theme }) => theme.colors.invert};
  padding: 3em 5em;
`

export const NormalMain = styled.div`
  padding: 3em 5em;
`

export const ErrorMsg = styled.div`
  width: 100%;
  padding: 1em 0;
  font-size: 1.5rem;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.error};
  align-items: center;
  justify-content: center;
  text-align: center;
`

export const ViewSection = styled.div`
  margin-top: 0.2em;
  width: 100%;
`

export const MainHeader = styled.div`
  font-size: 1.8rem;
  font-weight: bolder;
  padding-bottom: 10px;
  display: inline-block;
`

export const ProjectWorkArea = styled.div`
  height: 100%;
  float: none;
  clear: both;
`

export const ProjectListArea = styled.div`
  padding: 0px 0px 0.1em 0px;
`

export const NoProjectsMsg = styled.div`
  padding-top: 1em;
`

export const NoProjectsView = styled.div`
  width: 100%;
  position: absolute;
  background-color: ${({ theme }) => theme.project.noProjects.background};
  border: 2px dotted ${({ theme }) => theme.project.noProjects.border};

  bottom: 0;
  top: 7em;
`

export const NoProjectsContent = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -50px;
  transform: translate(-50%, -50%);
  align-items: center;
  justify-content: center;

  .new-project-button {
    height: 40px;
    position: relative;
    display: block;
    margin: auto;
    margin-top: 30px;
  }
`

export const NoProjectsTitle = styled.div`
  font-size: 1.4rem;
`

export const LeftBlock = styled.div`
  color: ${({ theme }) => theme.colors.invert};
  width: 50%;
  float: left;
  padding: 2px 2px 2px 0px;
`
export const RightBlock = styled.div`
  color: ${({ theme }) => theme.colors.invert};
  width: 50%;
  float: left;
  height: 24em;
  padding: 2px 0px 2px 2px;
`

export const ImageButton = styled.div`
  background: ${({ theme }) => theme.modal.header.background};
  color: ${({ theme }) => theme.colors.invert};
  width: 25%;
  height: 3em;
  font-size: 0.8rem;
  align-items: center;
  justify-content: center;
  display: inline-flex;
  position: relative;
  top: -25%;
  left: 40%;

  ${linkEffect} &:hover {
    background: ${({ theme }) => theme.modal.header.backgroundHover};
  }
`

export const BlockImage = styled.div`
  background: ${({ theme }) => theme.colors.inactive};
  width: 100%;
  height: 100%;
`

export const Divider = styled.div`
  height: calc(2em + 1px);
  border-top: 1px ${({ theme }) => theme.colors.light} solid;
  width: 100%;
  float: none;
  clear: both;
  margin: 1em 0;
`

export const TabDivider = styled.div`
  height: calc(2em + 1px);
  width: 100%;
  float: none;
  clear: both;
  margin: 1em 0;
  border-bottom: 1px ${({ theme }) => theme.colors.light} solid;
`

export const TabNormal = styled.div`
  font-weight: normal;
  height: calc(2em + 1px);
  display: inline-flex;
  border-bottom: 1px ${({ theme }) => theme.colors.light} solid;
  position: relative;
  top: 0px;
  cursor: pointer;

  &:hover {
    font-weight: bold;
    height: calc(2em + 1px);
    display: inline-flex;
    border-bottom: 5px ${({ theme }) => theme.colors.light} solid;
    position: relative;
    top: 2px;
  }
`

export const TabDisabled = styled.div`
  font-weight: normal;
  height: calc(2em + 1px);
  display: inline-flex;
  color: ${({ theme }) => theme.colors.light};
  border-bottom: 1px ${({ theme }) => theme.colors.light} solid;
  position: relative;
  top: 0px;
`

export const TabSelected = styled.div`
  font-weight: bold;
  height: calc(2em + 1px);
  display: inline-flex;
  border-bottom: 5px ${({ theme }) => theme.colors.brand} solid;
  position: relative;
  top: 2px;
  cursor: pointer;
`

export const TabFill = styled.div`
  font-weight: normal;
  height: calc(2em + 1px);
  display: inline-flex;
  border-bottom: 1px ${({ theme }) => theme.colors.light} solid;
  width: 3em;
  position: relative;
  top: 0px;
`

export const ProjectTools = styled.div`
  width: 100%;
  display: block;
  position: relative;
  float: none;
  padding: 2px 0px;
`

export const NewsTools = styled.div`
  width: 100%;
  display: block;
  float: none;
  clear: both;
  height: 3em;
  padding: 0px;
`

export const ToolBar = styled.div`
  width: 100%;
  display: block;
  float: none;
  clear: both;
  height: 3em;
`

export const ToolTitle = styled.div`
  font-size: 1.7rem;
  float: left;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 1em;
`

export const NormalButton = styled.button`
  position: absolute;
  right: 0;
  border: none;
  height: 100%;
  background: ${({ theme }) => theme.colors.brand};
  color: ${({ theme }) => theme.colors.invert};
  align-items: center;
  justify-content: center;
  display: inline-flex;
  padding: 0 2em;
  font-size: 0.8rem;
  font-weight: bolder;
  cursor: pointer;

  ${linkEffect} &:hover {
    background: ${({ theme }) => theme.hoverColors.brand};
  }
`

export const Alt1Button = styled.div`
  height: 100%;
  width: calc(25% - 2px);
  background: ${({ theme }) => theme.project.button.background};
  float: right;
  align-items: center;
  justify-content: center;
  display: inline-flex;
  font-size: 0.8rem;

  ${linkEffect} &:hover {
    background: ${({ theme }) => theme.project.button.hover};
  }
`

export const CreateNewProject = styled.div`
  width: 25%;
  height: 216px;
  background: ${({ theme }) => theme.project.button.background};
  float: left;
  border: 1px dotted;
  margin-top: 2px;
  font-size: 0.8rem;

  ${linkEffect} &:hover {
    background: ${({ theme }) => theme.project.button.hover};
    transform: none;
  }
`

export const NewProjectButton = styled.div`
  width: 100%;
  align-items: center;
  justify-content: center;
  display: inline-flex;
  position: relative;
  cursor: pointer;
  top: 40%;
  left: 0%;
`

export const ThumbView = styled.div`
  position: relative;
  display: inline-block;
  width: 311px;
  height: 175px;
  padding: 2px;
  float: left;
  flex-shrink: 0;
`

export const ImageDiv = styled.div`
  position: relative;
  background: #e3e6e5;
  color: ${({ theme }) => theme.colors.default};
  width: 100%;
  height: 100%;
  overflow: hidden;
  cursor: pointer;
`

export const ThumbButtonFullWidth = styled.div`
  width: 100%;
  height: 100%;
  bottom: 0;
  background: ${({ theme }) => theme.colors.brand};
  color: ${({ theme }) => theme.colors.invert};
  font-weight: bolder;

  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  ${linkEffectAlt} &:hover {
    background: ${({ theme }) => theme.hoverColors.brand};
  }
`

export const ImageCaption = styled.div`
  position: absolute;
  display: inline;
  left: 2em;
  height: 0px;
  top: 12px;
`

export const ImageCaptionHeader = styled.div`
  color: ${({ theme }) => theme.colors.default};
  font-size: 0.8rem;
  margin-bottom: 0.2em;
  font-weight: bold;
`

export const ImageCaptionDesc = styled.div`
  color: ${({ theme }) => theme.colors.default};
  font-size: 0.8rem;
`
export const ImageTools = styled.div`
  display: block;
  height: 48px;
  position: relative;
  top: -48px;
`

export const ThumbButtonL = styled.div`
  background: ${({ theme }) => theme.colors.brand};
  color: ${({ theme }) => theme.colors.invert};
  width: 50%;
  height: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  ${linkEffectAlt} &:hover {
    background: ${({ theme }) => theme.hoverColors.brand};
  }
`

export const ThumbButtonR = styled.div`
  background: ${({ theme }) => theme.colors.default};
  color: ${({ theme }) => theme.colors.invert};
  width: 50%;
  height: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  ${linkEffectAlt} &:hover {
    background: ${({ theme }) => theme.hoverColors.default};
  }
`

export const NewsHead = styled.div`
  font-size: 0.8rem;
  font-weight: normal;
  margin-bottom: 0.8em;
`

export const NewsBody = styled.div`
  font-size: 0.8rem;
  font-weight: light;
  margin-bottom: 0.8em;
`

export const TabWorkArea = styled.div`
  clear: both;
  width: 100%;
`

export const ProjectDetailLeft = styled.div`
  margin-top: 1em;
  width: 66%;
  height: 100%;
  border-right: 1px ${({ theme }) => theme.colors.light} solid;
  padding-right: 2em;
  float: left;
`

export const ProjectDetailRight = styled.div`
  margin-top: 1em;
  width: calc(33% - 1px);
  padding-left: 3em;
  float: left;
`

export const DetailRow = styled.div`
  font-size: 1rem;
  padding-top: 1em;
  min-height: 6em;
  width: 100%;
  clear: both;
  float: left;
  display: inline-flex;
`

export const DetailRowBig = styled.div`
  width: 100%;
  font-size: 1.4rem;
  padding-top: 1em;
  min-height: 5em;
  clear: both;
  float: left;
  display: inline-flex;
`

export const DescriptionRow = styled.div`
  width: 100%;
  font-size: 1em;
  padding-top: 1em;
  height: 11em;
  clear: both;
  float: left;
  display: inline-flex;
`

export const DetailTools = styled.div`
  width: 100%;
  float: right;
`

export const CaseListRow = styled.div`
  height: 100%;
  padding: 1em 0px;
  width: 100%;
  clear: both;
  float: left;
  display: inline-flex;
  border-bottom: 1px ${({ theme }) => theme.colors.light} solid;
`

export const CaseDetails = styled.div`
  height: 100%;
  padding-left: 3em;
  width: 100%;
`

export const ButtonNormal = styled.button`
  border: none;
  background: ${({ theme }) => theme.colors.brand};
  color: ${({ theme }) => theme.colors.invert};
  font-size: 1rem;
  width: auto;
  height: 2.4em;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: 1em;
  float: right;
  padding: 0px 2em;
  cursor: pointer;

  ${linkEffect} &:hover {
    background: ${({ theme }) => theme.hoverColors.brand};
  }

  ${linkEffect} &:disabled {
    background: ${({ theme }) => theme.colors.brand};
  }
`

export const ButtonPrimary = styled.button`
  border: none;
  background: ${({ theme }) => theme.colors.default};
  color: ${({ theme }) => theme.colors.invert};
  font-size: 1rem;
  width: auto;
  height: 2.4em;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: 1em;
  float: right;
  padding: 0px 2em;
  cursor: pointer;

  ${linkEffect} &:hover {
    background: ${({ theme }) => theme.hoverColors.default};
  }
`

export const Field = styled.div`
  padding-top: 0.5em;
  margin-right: 1em;
  max-width: 25%;

  .errorField {
    border-color: ${({ theme }) => theme.colors.error};
  }

  input:required {
    box-shadow: none;
  }
`

export const FieldWide = styled.div`
  padding-top: 0.5em;
  width: 100%;

  .errorField {
    border-color: ${({ theme }) => theme.colors.error};
  }
`

export const FieldHeader = styled.div`
  ${fieldBasics}
  border-color: ${({ theme }) => theme.colors.light};
`

export const FieldValue = styled.div`
  ${fieldValue}
  border-color: ${({ theme }) => theme.colors.light};
`

export const FieldBigValue = styled.div`
  ${bigFieldValue} font-size: 1.4rem;
  border-color: ${({ theme }) => theme.colors.light};
`

export const FieldInput = styled.input`
  ${fieldValue} border-style: solid;
  border-color: ${({ theme }) => theme.colors.light};
  border-width: 1px;
  padding-left: 0.2em;
  margin-right: 0.5em;
`

export const FieldBigInput = styled.input`
  ${bigFieldValue}
  border-color: ${({ theme }) => theme.colors.light};
  font-size: 1.4rem;
  border-style: solid;
  border-width: 1px;
  padding-left: 0.2em;
  margin-right: 0.5em;
`

export const CheckBoxInput = styled.input`
  ${fieldValue} border-style: solid;
  border-color: ${({ theme }) => theme.colors.light};
  border-width: 1px;
  padding-left: 0.2em;
  width: 2em;
  border-radius: 0px;
  color: ${({ theme }) => theme.colors.checked};
`

export const TextAreaInput = styled.textarea`
  font-weight: bold;
  font-size: 1rem;
  height: 8em;
  width: 100%;
  border-style: solid;
  border-width: 1px;
  border-color: ${({ theme }) => theme.colors.light};
`

export const FieldSelect = styled.select`
  ${fieldValue}
  border-color: ${({ theme }) => theme.colors.light};
  width: 10em;
  margin-right: 0.5em;
  background: ${({ theme }) => theme.colors.light};
  color: ${({ theme }) => theme.colors.invert};
  border-width: 1px;
  text-overflow: ellipsis;
`

export const FieldArrSelect = styled.select`
  ${fieldValue}
  border-color: ${({ theme }) => theme.colors.light};
  width: 10em;
  margin-right: 1.5em;
  background: ${({ theme }) => theme.colors.light};
  color: ${({ theme }) => theme.colors.invert};
  border-width: 1px;
  text-overflow: ellipsis;
`

export const EmbeddedLink = styled.span`
  padding-right: 0.5em;
  ${linkEffect};
  cursor: pointer;
`

export const ModalHead = styled.div`
  height: 3em;
  background: #00b0b9;
  color: ${({ theme }) => theme.colors.invert};
  font-weight: bold;
  align-items: center;
  display: flex;
  padding: 1em;
`

export const ModalMainText = styled.div`
  font-size: 1.4rem;
  text-align: center;
  padding: 0.1em 4em;
`

export const ModalRow = styled.div`
  display: block;
  font-size: 1rem;
  padding: 0.2em 0em;
`

export const ModalRowField = styled.div`
  float: left;
  padding-right: 1em;
`

const modalFieldBasics = 'margin-bottom: .5em; font-size: 1rem; width: 100%;'

export const ModalFieldHeader = styled.div`
  ${modalFieldBasics};
`

export const ModalFieldValue = styled.div`
  ${modalFieldBasics} font-weight: bold;
`

export const ModalTools = styled.div`
  clear: both;
  width: 100%;
  display: block;
  padding: 1em 0em 2em 0em;
`

export const ModalButtonNormal = styled.button`
  border: none;
  background: ${({ theme }) => theme.colors.brand};
  color: ${({ theme }) => theme.colors.invert};
  font-size: 1rem;
  width: calc(50% - 2em);
  height: 3.5em;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 0 1em;
  padding: 0px 2em;
  cursor: pointer;

  ${linkEffectAlt} &:hover {
    background: ${({ theme }) => theme.hoverColors.brand};
  }

  ${linkEffectAlt} &:disabled {
    background: ${({ theme }) => theme.colors.brand};
  }
`

export const ModalButtonPrimary = styled.button`
  border: none;
  background: ${({ theme }) => theme.colors.default};
  color: ${({ theme }) => theme.colors.invert};
  font-size: 1rem;
  width: calc(50% - 2em);
  height: 3.5em;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 0 1em;
  padding: 0px 2em;
  cursor: pointer;

  ${linkEffectAlt} &:hover {
    background: ${({ theme }) => theme.hoverColors.default};
  }

  ${linkEffectAlt} &:disabled {
    background: ${({ theme }) => theme.colors.default};
  }
`

export const modalStyle = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    padding: '0px',
    borderRadius: '0px',
    minWidth: 'auto',
    width: 'auto',
    maxHeight: '100%'
  },
  overlay: {
    zIndex: '1200'
  }
}



// WEBPACK FOOTER //
// ./src/Components/Projects/Styles.ts